import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import aceSapExportIssuesDe from "../modules/ace/customer-sap-export/i18n/de.json";
import aceSapExportIssuesEn from "../modules/ace/customer-sap-export/i18n/en.json";
import arcadeDe from "../modules/arcade/i18n/de.json";
import arcadeEn from "../modules/arcade/i18n/en.json";
import fighterDe from "../modules/arcade/fighter/i18n/de.json";
import fighterEn from "../modules/arcade/fighter/i18n/en.json";
import parkingDe from "../modules/arcade/parking/i18n/de.json";
import parkingEn from "../modules/arcade/parking/i18n/en.json";
import casaviDe from "../modules/casavi/i18n/de.json";
import casaviEn from "../modules/casavi/i18n/en.json";
import fabDe from "../modules/fab/i18n/de.json";
import fabEn from "../modules/fab/i18n/en.json";
import fiaDe from "../modules/fia/i18n/de.json";
import fiaEn from "../modules/fia/i18n/en.json";
import fitDe from "../modules/fit/i18n/de.json";
import fitEn from "../modules/fit/i18n/en.json";
import homeDe from "../modules/home/i18n/de.json";
import homeEn from "../modules/home/i18n/en.json";
import masterdataDe from "../modules/masterdata/i18n/de.json";
import masterdataEn from "../modules/masterdata/i18n/en.json";
import notificationDe from "../modules/notification/i18n/de.json";
import notificationEn from "../modules/notification/i18n/en.json";
import phonebookDe from "../modules/phonebook/i18n/de.json";
import phonebookEn from "../modules/phonebook/i18n/en.json";
import ramDe from "../modules/ram/i18n/de.json";
import ramEn from "../modules/ram/i18n/en.json";
import userSettingsDe from "../modules/user-settings/i18n/de.json";
import userSettingsEn from "../modules/user-settings/i18n/en.json";
import viewsDe from "../views/common/i18n/de.json";
import viewsEn from "../views/common/i18n/en.json";
import commonDe from "./de/common.json";
import commonEn from "./en/common.json";

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        phonebook: phonebookEn,
        home: homeEn,
        ram: ramEn,
        fab: fabEn,
        fia: fiaEn,
        fit: fitEn,
        casavi: casaviEn,
        masterdata: masterdataEn,
        notification: notificationEn,
        arcade: arcadeEn,
        fighter: fighterEn,
        parking: parkingEn,
        views: viewsEn,
        "user-settings": userSettingsEn,
        aceSapExportIssues: aceSapExportIssuesEn,
      },
      de: {
        common: commonDe,
        phonebook: phonebookDe,
        home: homeDe,
        ram: ramDe,
        fab: fabDe,
        fia: fiaDe,
        fit: fitDe,
        casavi: casaviDe,
        masterdata: masterdataDe,
        notification: notificationDe,
        arcade: arcadeDe,
        fighter: fighterDe,
        parking: parkingDe,
        views: viewsDe,
        "user-settings": userSettingsDe,
        aceSapExportIssues: aceSapExportIssuesDe,
      },
    },
    fallbackLng: "de",
    interpolation: { escapeValue: false },
    defaultNS: "common",
  });

export default i18next;
